<template>
	<div class="checklist-view">
        <chillNavbar path_title="current_visit_and_type" :current_visit="singleChecklist.store_name_app" :craft="singleChecklist.type" />
        <div class="checklist-box" >
            <div class="checklist-box-info" v-if="singleChecklist">
                <h2>{{trans(singleChecklist.name)}}</h2>
                <span class="title">{{trans(singleChecklist.type)}}</span>
            </div>

            <div class="checklist-box-image">
                <div class="checklist-box-image-left">
                    <label class="title">{{trans('front_image')}} </label>
                    <imageInput :keyValue="'front_image'" :imagePath="localChecklist['front_image']" @change="imageChange" />
                </div>
                <div class="checklist-box-image-right">
                    <label class="title">{{trans('type_plate_image')}} </label>
                    <imageInput :keyValue="'type_plate_image'" :imagePath="localChecklist['type_plate_image']" @change="imageChange" />
                    
                </div>
            </div>
        </div>
        <div v-if="singleChecklist.old_comments" class="old-comment-section">
            <span class="title">{{trans('old_comments')}}</span>
            <span v-for="c in singleChecklist.old_comments" v-bind:key="c">
                <li>{{c}}</li>
            </span>

        </div>
        <div class="form-field-row">
            <div class="form-field-input">
                <label for="formName" class="title">{{trans('name')}}</label>
                <input class="input-field" id="formName" @blur="updateData()" @keyup.enter="updateData()" v-model="localChecklist.name" type="text" />
            </div>
        </div>
        <div v-for="idKey of ['equipment_id','assets_id']" :key="idKey" class="form-field-row">
            <div class="form-field-input">
                <label for="formName" class="title">{{trans(idKey)}}</label>
                <input class="input-field" id="formName" @blur="updateData()" @keyup.enter="updateData()" v-model="localChecklist[idKey]" type="text" />
            </div>
        </div>
        <div v-if="localChecklist['old_type_plate_image']" class="form-field-image">
            <div class="image-content">
                <span class="title"><tr>{{trans('type_plate_image')}}</tr></span> 
                <span class="title"><tr>{{trans('type_plate_image_explanation')}}</tr></span>
            </div>
            <div class="image-content-image">
                <imageInput :keyValue="'type_plate_image'" :imagePath="localChecklist['type_plate_image']" @change="imageChange" />
            </div>
        </div>
        <div class="form-field-row" v-for="(key,i) in checklistOrderToShow" :key="key+i">
            <div v-if="statementCheck(checklistStrucuture[key])" class="form-field-box">


                <p v-if="key != 'special_filter' && key != 'special_belt'" class="title">{{trans(key)}}</p>
                <p v-else-if="key == 'special_filter' && parseInt(localChecklist['amount_of_filter_change']) > 0" class="title">{{trans('special_filter')}}</p>
                <p v-else-if="key == 'special_filter' " class="title">{{trans('no_special_filter')}}</p>
                <p v-else-if="key == 'special_belt' && parseInt(localChecklist['amount_of_belt_change']) > 0" class="title">{{trans('special_belt')}}</p>
                <p v-else-if="key = 'special_belt'" class="title">{{trans('no_special_belt')}}</p>


                <div v-if="checklistStrucuture?.[key].type == 'checkbox'  && statementCheck(checklistStrucuture[key])" class="checkbox-field" >
                    <div class="checklist-choices-box">
                        <div class="checkbox-box">
                            <label class="check-left">{{trans('working')}}
                                <input type="radio" :id="'working_'+key" value="working" @change="updateData()" v-model="localChecklist[key]" />
                            </label>
                        </div>
                        <div class="checkbox-box">
                            <label class="check-center">{{trans('not_working')}}
                                <input type="radio" :id="'mot_working_'+key" value="not_working" @change="updateData()" v-model="localChecklist[key]" />
                            </label>
                        </div>
                        <div class="checkbox-box">
                            <label class="check-right">{{trans('n/a')}}
                                <input type="radio" :id="'na_'+key" :value="'n/a'" @change="updateData()" v-model="localChecklist[key]" />
                            </label>
                        </div>
                    </div>
                </div>

                <label v-else-if="checklistStrucuture[key].type === 'text'  && statementCheck(checklistStrucuture[key])"><input @change="updateData()" v-model="localChecklist[key]" type="text" name="" id="" class="input-field"></label>
                <label v-else-if="checklistStrucuture[key].type === 'checkbox'  && statementCheck(checklistStrucuture[key])"><input @change="updateData()" v-model="localChecklist[key]" type="checkbox" class="input-field"></label>
                <label v-else-if="checklistStrucuture[key].type === 'int'  && statementCheck(checklistStrucuture[key])"><input @change="updateData()" v-model="localChecklist[key]" type="number" @keypress="isNumber($event)" class="input-field"></label>
                <label v-else-if="checklistStrucuture[key].type === 'free_text'  && statementCheck(checklistStrucuture[key])"><textarea @change="updateData()" v-model="localChecklist[key]" type="text" name="" id="" class="text-area"></textarea></label>
                <label v-else-if="checklistStrucuture[key].type === 'string'  && statementCheck(checklistStrucuture[key])"><textarea @change="updateData()" v-model="localChecklist[key]" type="text" name="" id="" class="input-field"></textarea></label>
                <label v-else-if="checklistStrucuture[key].type === 'option'  && statementCheck(checklistStrucuture[key])">
                    <v-select :id="'select-'+key" v-model="localChecklist[key]" :options="genereateOptions(checklistStrucuture[key].options)" :reduce="o => o.value" label="key" @input="updateData()"/>
                </label>
                <label v-else-if="checklistStrucuture[key].type === 'multiple_option'  && statementCheck(checklistStrucuture[key])">
                    <v-select multiple :id="'select-'+key" v-model="localChecklist[key]" :options="genereateOptions(checklistStrucuture[key].options)" :reduce="o => o.value" label="key" @input="updateData()"/>
                </label>
                <span v-else-if="checklistStrucuture[key].type === 'bool' && statementCheck(checklistStrucuture[key])" class="bool-element">
                    <label><input type="radio" @change="updateData(key)" value="yes" v-model="localChecklist[key]" id="one">{{trans('yes')}}</label>
                    <label><input type="radio" @change="updateData(key)" value="no" v-model="localChecklist[key]" id="two">{{trans('no')}}</label>
                </span>
                
                <div v-else-if="checklistStrucuture[key].type === 'image'" class="image-content-image">
                    <imageInput :keyValue="key" :imagePath="localChecklist[key]" @change="imageChange" />
                </div>

                <!-- SPECIAL_BELT -->
                <div v-else-if="checklistStrucuture[key].type === 'special_belt' && parseInt(localChecklist['amount_of_belt_change']) > 0 " class="image-content-image">
                    <chill-belt :edit="true" :cData="localChecklist" :updateData=updateData :imageChange="imageChange" :structure="checklistStrucuture" :k="key"></chill-belt>
                </div>

                <!-- SPECIAL_FILTER -->
                <div v-else-if="checklistStrucuture[key].type === 'special_filter' && parseInt(localChecklist['amount_of_filter_change']) > 0 " class="image-content-image">
                    <chill-filter :edit="true" :cData="localChecklist" :updateData=updateData :imageChange="imageChange" :structure="checklistStrucuture" :k="key"></chill-filter>
                </div>
            </div>

        </div>

        <div class="form-field-row" v-if="Object.values(localChecklist).includes('not_working')">
            <div class="general-comment">
                <p class="title">{{trans('deficiency_service_company_image')}}</p>
                <imageInput :keyValue="'deficiency_service_company_image'" :imagePath="localChecklist['deficiency_service_company_image']" @change="imageChange" />
                <br/>
                <label class="title">{{trans('deficiency_service_company_text')}}
                    <textarea class="textarea-bottom text-area"  @change="updateData()" v-model="localChecklist['deficiency_service_company_text']" type="text" name="" id="" ></textarea>
                </label>
            </div>
        </div>

        <div class="form-field-row">

            <div class="general-comment">
                <label class="title">{{trans('comment')}}
                    <textarea class="textarea-bottom text-area"  @change="updateData()" v-model="localChecklist['comment']" type="text" name="" id="" ></textarea>
                </label>
            </div>
        </div>
        <div class="button-box">
            <button class="button-box-element" @click="checklist_done()" >{{trans('Done')}}</button>
        </div>
	</div>
</template>

<script>
	export default {
		name: 'checklist',

		data() {
			return {
				localChecklist: {},
                checkboxTest: 'no value'
			}
		},
		watch: {
			singleChecklist: {
                handler(data){
                    if(!this.checklistStrucuture.order && (this.singleChecklist && this.singleChecklist.type)){
                        this.startChecklistStrucutre(this.singleChecklist.type)
                    }
                    this.localChecklist = JSON.parse(JSON.stringify(data))
                },
                deep: true
            },
		},
        computed: {
            checklistOrderToShow() {
                if(this.checklistStrucuture?.order) {
                    let removedErrorQuestions = [...this.checklistStrucuture.order]
                    removedErrorQuestions = removedErrorQuestions.filter(item => item !== "deficiency_service_company_image")
                    removedErrorQuestions = removedErrorQuestions.filter(item => item !== "deficiency_service_company_text")
                    const filtredOrder = removedErrorQuestions.filter(key => {
                        return this.statementCheck(this.checklistStrucuture[key], key) ? key : null
                    })
                    
                    return filtredOrder
                }
                else {
                    return ''
                }
            }
        },
		methods: {
            isNumber(evt){
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            genereateOptions(options){
                let re = []
                for(let o of options){
                    re.push({key: this.trans(o), value: o})
                }
                return re
            },
			async imageChange(key, base64){
				let url = await this.upload_image(this.$route.params.visit_id, this.$route.params.checklist_id, base64);
				this.localChecklist[key] = url;
				this.updateData()

			},
            async imageListChange(key, base64){
                if(!this.localChecklist[key]){
                    this.localChecklist[key] = []
                }
                let url = await this.upload_image(this.$route.params.visit_id, this.$route.params.checklist_id, base64);
                this.localChecklist[key].push(url);
                this.updateData()

            },
            statementCheck(struct, key="error_value_if_key_is_not_set"){
                if(!struct){
                    console.warn("no struct exists for: ", key)
                }
                if(struct.statement){
                    if(struct.statement.type == "equal"){
                        if(this.localChecklist[struct.statement.key] == struct.statement.value){
                            return true
                        }
                    }
                }else{
                    return true
                }
            },
			updateData(){
                this.localChecklist["started"] = true
				this.updateChecklist(this.$route.params.checklist_id, this.$route.params.visit_id, this.localChecklist)
			},
			checklist_done(){
                this.updateChecklist(this.$route.params.checklist_id, this.$route.params.visit_id, {done: true})
				this.$router.push({ path: `/visit/${this.$route.params.market_id}/${this.$route.params.visit_id}` });
			}
		},
		mounted(){
			this.startSingleChecklistListener(this.$route.params.visit_id, this.$route.params.checklist_id)
		}
	}
</script>

<style lang="scss">
    .vs__dropdown-toggle {
        border: none !important;
        border-bottom: solid #565760 1px!important;
        border-radius: 0px !important;
        &:focus {
            outline: none !important;
            border-bottom: solid #51D07D 1px !important;
        }
    }
</style>

<style scoped lang="scss">
    .checklist-view {
        margin: 150px auto 0px auto;
        width: 86vw;
        max-width: 900px;


        .checklist-box-answerd {
            display: flex;
            flex-direction: column;
            margin-bottom: 8px;

            background-color: #fff;
            justify-content: space-between;
            border-left: solid #cae41d 5px;
            width: 100%;
            padding: 0px 8px 12px 8px;
            box-sizing: border-box;
            .checklist-box-info {
                display: flex;
                flex-direction: column;
                margin-bottom: 8px;
            }
            .checklist-box-image {
                /* overflow: hidden; */
                display: flex;
                justify-content: space-between;
                .checklist-box-image-left {
                    text-align: center;
                }
                .checklist-box-image-right {
                    align-items: center;
                    display: flex;
                    flex-direction: column;
                    .un-change-image {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .small-image {
                        width: 110px;
                        height: 110px;
                        border-radius: 4px;
                    }
                }
            }
        }




        .checklist-box {
            display: flex;
            flex-direction: column;
            margin-bottom: 8px;

            background-color: #fff;
            justify-content: space-between;
            border-left: solid #1B608C 5px;
            width: 100%;
            padding: 0px 8px 12px 8px;
            box-sizing: border-box;
            .checklist-box-info {
                display: flex;
                flex-direction: column;
                margin-bottom: 8px;
            }
            .checklist-box-image {
                /* overflow: hidden; */
                display: flex;
                justify-content: space-between;
                .checklist-box-image-left {
                    text-align: center;
                }
                .checklist-box-image-right {
                    align-items: center;
                    display: flex;
                    flex-direction: column;
                    .un-change-image {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .small-image {
                        width: 110px;
                        height: 110px;
                        border-radius: 4px;
                    }
                }
            }
        }
        .old-comment-section {
            margin-top: 15px;
        }
        .form-field-image {
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            width: 100%;
            margin: 8px 0px;
            background-color: #fff;
            border-left: solid #1B608C 5px;
            padding: 0px 8px 12px 8px;
            box-sizing: border-box;
            .image-content {
                display: flex;
                flex-direction: column;
            }
            .image-content-image {
                margin-bottom: 4px;
            }
        }
        .form-field-row {
            width: 100%;
            margin: 8px 0px;
            background-color: #fff;
            display: flex;
            justify-content: space-between;
            border-left: solid #1B608C 5px;
            padding: 0px 8px 12px 8px;
            box-sizing: border-box;
            .form-field-input {
                width: 100%;
                // .input-field { }
            }
            .input-field {
                border: none;
                border-bottom: solid #565760 1px;
                &:focus {
                    outline: none;
                    border-bottom: solid #51D07D 1px;
                }
            }
            .form-field-box {
                width: 100%;
                .input-field {
                    border: none;
                    border-bottom: solid #565760 1px;
                    &:focus {
                        outline: none;
                        border-bottom: solid #51D07D 1px;
                    }
                }
                .bool-element {
                    display: flex;
                    margin: 0px 12px;
                    > label {
                        display: flex;
                        flex-direction: column-reverse;
                        width: 33%;
                        // &:nth-child(1) {
                        //     align-items: center;
                        // }
                        &:nth-child(2) {
                            align-items: center;
                        }
                    }
                }
                .checkbox-field {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding-bottom: 4px;
                    .checklist-choices-box {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-right: 10px;
                        margin-left: 10px;
                        .checkbox-box {
                            display: flex;
                            align-items: center;
                            flex-direction: column;
                            margin-bottom: 4px;
                            > label {
                                display: flex;
                                flex-direction: column;
                                align-items: center
                            }
                            .check-left {
                                align-items: flex-start;
                            }
                            .check-center {
                                align-items: center;
                            }
                            .check-right {
                                align-items: flex-end;
                            }
                        }
                    }
                }
                .image-content-image {
                    margin-left: auto;
                    margin-bottom: 4px;
                }
                textarea {
                    padding-top: 4px;
                    border: none;
                    border-bottom: solid #565760 1px;
                    border-radius: 0px;
                    &:focus {
                        outline: none;
                        border-bottom: solid #51D07D 1px;
                    }
                }
            }
            .general-comment {
                display: flex;
                flex-direction: column;
                width: 100%;
                .textarea-bottom {
                    height: 100px;
                    border: none;
                    border-bottom: solid #565760 1px;
                    border-radius: 0px;
                    &:focus {
                        outline: none;
                        border-bottom: solid #51D07D 1px;
                    }
                }
            }
        }
        .button-box {
            width: 100%;
            margin-top: 18px;
            margin-bottom: 34px;
            .button-box-element {
                width: 200px;
                background-color: #1B608C;
                color: #FFF;
                height: 28px;
                border-radius: 28px;
                border: none;
                &:hover {
                    cursor: pointer;
                }
            }
        }
    }
    

    input[type=text], input[type=number], textarea {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
    }

    input[type=radio] {
        position: relative;
        appearance: none;
        //margin-left: 0
    }
    input[type=radio]::before {
        content: '❏';
        font-family: 'FontAwesome';
        font-size: 120%;
        display: inline-block;
        letter-spacing: .75em
    }

    input[type=radio]:checked::before
    {
        content: '✓';
        color: #000000;
    }

    label {
        font-size: 14px;
        font-weight: 200;
    }
    .title {
        font-size: 14px;
        color: #191A23;
        font-weight: 400;
        margin: 4px;
    }
    h3 {
        font-weight: normal;
        font-size: 16px;
        margin-top: 0px;
    }

</style>